import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { AuthService, ResolverLoadingService } from 'pbc.angular';

import { IObjektArtsResponse } from 'fa-kt.types';
import { PostObjektArtCommandService } from '../commands';
import { ObjektArtsService } from '../query';

@Injectable({
  providedIn: 'root',
})
export class ObjektArtsPageResolver implements Resolve<IObjektArtsResponse | void> {
  constructor(
    private loading: ResolverLoadingService,
    private authService: AuthService,
    private objektArts: ObjektArtsService,
    private postObjektArt: PostObjektArtCommandService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<IObjektArtsResponse | void> {
    this.loading.resolving();
    const log = (error: any) => console.error(error);
    const [objektArts] = await Promise.all([this.objektArts.request({}).catch(log), this.postObjektArt.prepare(true).catch(log)]);
    this.loading.resolved();
    return objektArts;
  }
}
